var render = function render(){var _vm=this,_c=_vm._self._c;return _c('center',[_c('h1',[_vm._v("Pagina non trovata!")]),_c('p',[_c('a',{attrs:{"href":"/"}},[_vm._v("Torna alla homepage")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }